
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppShell from './AppShell';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>
);
